import {getPaymentStatusText} from '../../../../components/insights/invoicing/InvoicingUtil';
import Util from '../util';
import DataExportFormatter from './DataExportFormatter';
import {composeClientContactName} from '../clientContactName';

export default class InvoiceFormatter extends DataExportFormatter {
	_columnFormatHook(name) {
		return name
			.split(/(?=[A-Z])/)
			.map(word => word.toLocaleLowerCase())
			.join('_');
	}

	_getFormattedValueHook(column, invoice) {
		const invoiceTotal = invoice.invoicedWithoutTax;
		const invoicePaid = invoice.paidWithoutTax;

		switch (column) {
			case 'invoice_id':
				return invoice.companyInvoiceId;
			case 'invoice_name':
				return invoice.name;
			case 'client':
				return invoice.client ? invoice.client.name : '';
			case 'contact':
				return composeClientContactName(invoice.clientContact);
			case 'project_ids':
				return invoice.projects.map(project => project.customProjectId).join(',');
			case 'project_names':
				return invoice.projects.map(project => project.name).join(',');
			case 'status':
				return invoice.isImported ? 'IMPORTED' : invoice.status;
			case 'payment_status':
				return getPaymentStatusText(invoice.paymentStatus, this._intl);
			case 'xero_status':
			case 'quickbooks_status':
			case 'sage_intacct_status':
			case 'economic_status':
				return Util.getInvoiceStatusTranslation(invoice.externalStatus, this._intl);
			case 'reference':
				return invoice.invoiceReference;
			case 'invoice_number':
				return invoice.invoiceNumber;
			case 'date':
				return this._formatDate(invoice.createdDay, invoice.createdMonth, invoice.createdYear);
			case 'due_date':
				return this._formatDate(invoice.dueDay, invoice.dueMonth, invoice.dueYear);
			case 'invoiced_amount':
				return invoiceTotal;
			case 'paid_amount':
				return invoicePaid;
			case 'unpaid_amount':
				return invoiceTotal - invoicePaid;
			case 'currency':
				return invoice.currency;
			default:
				return null;
		}
	}
}
